import React , {useState, useEffect, useRef, createContext}from 'react'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import HeaderComponent from '../HelloTrade/HeaderComponent'
import CaraousalComponent from '../HelloTrade/CaraousalComponent'
import FeatureComponent from '../HelloTrade/FeatureComponent'
import OurPartnersComponent from '../HelloTrade/OurPartnersComponent'
import FooterComponent from '../HelloTrade/FooterComponent'
import FormComponent from '../HelloTrade/FormComponent'
import SideBarComponent from '../BureauJourney/Components/SideBarComponent'
import OTPComponent from '../BureauJourney/Components/OTPComponent'
import BankingComponent from '../BureauJourney/Components/BankingComponent'
import ThanksComponent from '../BureauJourney/Components/ThanksComponent'
import MoreDetailsComponent from '../BureauJourney/Components/MoreDetailsComponent'
import { gatrack } from '../../utils'
import "../../CssFiles/newHome.css"

export const BureauContext = createContext();

export default function HelloTradePage() {
    const navigate = useNavigate();   
    const [displayPage, setDisplayPage] = useState(1);
    const [userInfo, setUserInfo] = useState({ name: '', pan: '', mob: '', glid:'', fn:'', ln:'', mn:'', updatedMob:'', otpTime:'', consentTime:'', writeStatus:1, trsId:0,maskedMob:'',ak:''});
    const [moreInfo, setMoreInfo] = useState({gst:'', bisAdd:'', bisPin:''});
    const [defaultUserInfo, setDefaultUserInfo] = useState({ name: '', pan: '', mob: '', glid:'', fn:'', ln:'', mn:'', updatedMob:'', otpTime:'', consentTime:'', writeStatus:1, trsId:0,maskedMob:'',ak:''});
    const [otpScreen, setOtpScreen] = useState('');
    const [phoneError, setPhoneError] = useState(false);
    const [token, setToken] = useState('');
    const [gstAvailable, setGstAvailable] = useState(true);
    const hasCalled = useRef(false);
    const contextValue = {displayPage, setDisplayPage, otpScreen, setOtpScreen, userInfo, setUserInfo, phoneError, setPhoneError, defaultUserInfo, setDefaultUserInfo, token, gstAvailable, moreInfo };

    const getUserInfo = async () => {

        const cleanQuery = window.location.search.substring(1);

        const parts = cleanQuery.split("&userSourceData=");
        const encString = parts[0] || "";  
        const sourceData = parts[1] || "";       

        const encVal = encString.includes("encVal=") ? encString.replace("encVal=", "") : "";

        const host = window.location.hostname;

        const redirectUrl = host == 'www.hellotrade.com' 
            ? "https://loans.indiamart.com?from=HelloTrade" 
            : "http://localhost:3002?from=HelloTrade"

        //console.log("encval =>", encVal, "all other params =>", sourceData);
        if(encVal == ""){
            window.location.href = redirectUrl;
        }

        const url = host === 'www.hellotrade.com'
            ? 'https://www.hellotrade.com/api/v1/getDecVal'
            : 'https://dev.hellotrade.com/api/v1/getDecVal';

        const formData = new FormData();
        formData.append('encVal', encVal);

        try {

            const response = await axios({
                method: 'post',
                url: url,
                data: formData,
                timeout: 3000
            });

            const data_obj = response.data;
            //console.log("Data recieved: ", data_obj);
            if (data_obj.CODE == '200') {
                //console.log("Decoded value recieved from url => ", data_obj);
                let fn = data_obj.OUTPUT.firstName || '';
                let mn = data_obj.OUTPUT.middleName || '';
                let ln = data_obj.OUTPUT.lastName || '';
                let glid = data_obj.OUTPUT.GLID || '';
                let pan = data_obj.OUTPUT.PAN || '';
                let mob = data_obj.OUTPUT.Phone || '';
                let busiName = data_obj.OUTPUT.businessName || '';
                let maskedMob = data_obj.OUTPUT.maskedMob || '';
                let bisAdd = data_obj.OUTPUT.Business_Address|| '';
                let bisPin = data_obj.OUTPUT.Business_Pincode || '';
                let gst = data_obj.OUTPUT.GST || '';
                let ak = data_obj.OUTPUT.AK || '';

                
                if(glid == '' || ak == ''){
                    window.location.href = redirectUrl;
                }
                gatrack("HT Journey", "Landing", "HomePage", glid)
                //setUserSession(glid, gst, bisAdd, bisPin);
                const fullName = [fn, mn, ln].filter(Boolean).join(' ');
                {glid != "" && getJourneyStatus(glid)};

                // if(glid != ""){
                //     if(glid == "59002668"){
                //         setDisplayPage(3);
                //     } else{
                //         getJourneyStatus(glid);
                //     }
                // }

                if(pan.charAt(3) == 'P'){
                    setUserInfo((prevInfo)=>({...prevInfo, name: fullName, pan: pan, mob: mob, glid: glid, fn: fn, ln: ln, mn: mn, updatedMob:mob, busiName:busiName,dob:'',maskedMob:maskedMob, ak : ak}))

                    setDefaultUserInfo((prevInfo)=>({...prevInfo, name: fullName, pan: pan, mob: mob, glid: glid, fn: fn, ln: ln, mn: mn, updatedMob:mob, busiName:busiName,dob:'',maskedMob:maskedMob, ak : ak}))
                } 
                else{
                    setUserInfo((prevInfo)=>({...prevInfo, name: '', pan: '', mob: mob, glid: glid, fn: '', ln: '', mn: '', updatedMob:mob, busiName:busiName,dob:'',maskedMob:maskedMob, ak : ak}))

                    setDefaultUserInfo((prevInfo)=>({...prevInfo, name: '', pan: '', mob: mob, glid: glid, fn: '', ln: '', mn: '', updatedMob:mob, busiName:busiName, dob:'',maskedMob:maskedMob, ak : ak}))
                }


                getConsentStatus(glid, mob, fn, mn, ln);
                setMoreInfo((prevInfo)=>({...prevInfo, gst:gst, bisAdd:bisAdd, bisPin:bisPin}));
                markLanding(glid, busiName, fullName, pan, mob, sourceData);
            }
            else{
                setGstAvailable(false);
                gatrack("HT Journey", "Landing", "HomePage", "NO GLID")
                window.location.href = redirectUrl;

            }

        } catch (error) {
            console.error('Error fetching decoded data:', error);
            gatrack("HT Journey", "Landing", "HomePage", "GLID Error")
            window.location.href = redirectUrl;
        }
    }

    const markLanding = async (glid, bisName, userName, pan, mob, sourceData) => {
        try {
            // Wait for token value
            // const tokenVal = await getToken(glid);

            // if (!tokenVal) {
            //     console.error("Token value is null or undefined, cannot proceed with API call.");
            //     return;
            // }

            const host = window.location.hostname;
            const apiURL =
                host === 'www.hellotrade.com'
                    ? "https://loans.indiamart.com/api/v1/captureLanding"
                    : "https://dev-loans.indiamart.com/api/v1/captureLanding";

            // Prepare input data
            const inData = {
                "glid": glid,
                "bname": bisName,
                "iname": userName,
                "pan": pan,
                "updatedMob": mob,
                "src":"HelloTrade",
                "srcData":sourceData
            };

            const formData = new FormData();
            for (const key in inData) {
                formData.append(key, inData[key]);
            }

            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-api-key': ''
                },
                url: apiURL,
                data: formData,
                timeout: 2000
            });

            if (response.data?.CODE === "200") {
               // console.log("API Response:", response.data);
            } else {
                console.error("Unexpected response from API:", response.data);
            }
        } catch (error) {
            console.error("An error occurred in markLanding:", error);
        }
    };

    const getToken = async (val) => {
        try {
            const host = window.location.hostname;
            const apiURL =
                host === 'www.hellotrade.com'
                    ? "https://loans.indiamart.com/api/v1/getToken"
                    : "https://dev-loans.indiamart.com/api/v1/getToken";

            const inData = {
                "val": val
            };

            const formData = new FormData();
            for (const key in inData) {
                formData.append(key, inData[key]);
            }

            const response = await axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: apiURL,
                data: formData,
                timeout: 2000
            });

            if (response.data?.CODE === "200") {
                const tk = response.data.VALUE;
                setToken(tk);
                return tk; // Return token value
            } else {
                console.error("Failed to fetch token. Response:", response.data);
                return null;
            }
        } catch (error) {
            console.error("An error occurred while fetching token:", error);
            return null;
        }
    };

    const getConsentStatus = async(glid, mob, fn, mn,ln) =>{
        const host = window.location.hostname;
        const url = host === 'www.hellotrade.com'
            ? 'https://www.hellotrade.com/api/v1/getBureauStatus'
            : 'https://dev.hellotrade.com/api/v1/getBureauStatus';


        const postData = {
            glid:glid,
            phone:mob,
            fn:fn,
            mn:mn,
            ln:ln
        }

        const formData = new FormData();
        for (const key in postData) {
            if (postData.hasOwnProperty(key)) {
                formData.append(key, postData[key]);
            }
        }

        try {

            const response = await axios({
                method: 'post',
                url: url,
                data: formData,
                timeout: 5000
            });

            const data_obj = response.data;
            console.log("Data recieved from consent API: ", data_obj);
            if(data_obj && data_obj.CODE == "200"){
                let stat = data_obj.STATUS||1;
                let trs = data_obj.MAXID || 0;
                setUserInfo((prevInfo)=>({...prevInfo, writeStatus:stat, trsId:trs}))
                if(stat == 2 || stat == 3){
                    //setDisplayPage(4)
                }
            } else{
                console.error("Data object not present in consent API or CODE is not 200")
            }

        } catch (error) {
            console.error('Error fetching Consent Status:', error);
        }
    }


    const getJourneyStatus = async(glid) =>{
        const host = window.location.hostname;
        const url = host === 'www.hellotrade.com'
            ? 'https://loans.indiamart.com/api/v1/getJourneyFlags'
            : 'https://dev-loans.indiamart.com/api/v1/getJourneyFlags';


        const postData = {
            "glid":glid,
            "stage":"raw",
        }

        const formData = new FormData();
        for (const key in postData) {
            if (postData.hasOwnProperty(key)) {
                formData.append(key, postData[key]);
            }
        }

        try {

            const response = await axios({
                method: 'post',
                url: url,
                data: formData,
                timeout: 5000
            });

            const data_obj = response.data;

            //console.log("Data recieved from loans journey stat API: ", data_obj);
            if(data_obj && data_obj.code == "200"){
                let result = data_obj.result;
                if(glid == '132160368' || glid == '195143359' || glid == '236346447'){
                    setDisplayPage(1)
                }
                else if(result.AddInfoFlag == "true"){
                    //console.log("Show Thanks Page")
                    setDisplayPage(4)
                } else if(data_obj.bankingStatus == "true"){
                    //console.log("Show Add info Page")
                    setDisplayPage(5)
                } else{
                    if(result.bureauStat == "true" || result.consent == "true"){
                        //console.log("Show banking Page")
                        setDisplayPage(3)
                    }
                }
            } else{
                console.error("Data object not present in journey stat API or CODE is not 200")
            }

        } catch (error) {
            console.error('Error fetching journey Status:', error);
        }
    }

    useEffect(() => {
        
        if (!hasCalled.current) {
            hasCalled.current = true;
            getUserInfo();
        }
    }, []);

  return (
      <>  <BureauContext.Provider value={contextValue}>
          <div id="homePage" className={displayPage !== 1 ? "homePage" : ""}>
              {displayPage != 1 && <div style={{ width: '100%' }}>
                  <div className='msite_header'><HeaderComponent /></div>
                  <div style={{ display: "flex" }}>
                      <SideBarComponent />

                      {displayPage == 2 && <OTPComponent />}
                      {displayPage == 3 && <BankingComponent />}
                      {displayPage == 4 && <ThanksComponent />}
                      {displayPage == 5 && <MoreDetailsComponent />}
                  </div>
              </div>
              }

              {displayPage == 1 &&
                  <>
                      <HeaderComponent />
                      <FormComponent />
                  </>
              }
          </div>
          {userInfo.glid === "6601433" && (
              <div
                  style={{
                      width: "200px",
                      height: "100px",
                      backgroundColor: "#4CAF50", // Nice green background
                      color: "#fff", // White text for contrast
                  }}
                  onClick={() => navigate("/appTest")} // Add your onClick logic here
              >
                  Test Android
              </div>
          )}
      </BureauContext.Provider>
      </>
    
  )
}